import Vue from 'vue'

// axios
import axios from 'axios'

let baseURL;

const prodURL = window.location.origin.includes('prod');
const homologURL = window.location.origin.includes('homolog');

if(prodURL){
  baseURL = 'https://app-indsiders-azimut-api-prod.azurewebsites.net'
}
else if(homologURL){
  baseURL = 'https://app-troika-azimut-api-homolog.azurewebsites.net'
}
else{
  baseURL = 'https://app-troika-azimut-api-dev.azurewebsites.net'
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL,
  headers: { 'accept':'application/json'}
  // timeout: 1000,

})
if(localStorage.getItem(('userData'))){
  axiosIns.defaults.headers.common = {'user-guid': JSON.parse(localStorage.getItem('userData')).guid};
}
Vue.prototype.$http = axiosIns


export default axiosIns
